import { Component, OnChanges, Input } from '@angular/core';
import {  VehicleJobListItemDto, JourneyItemDto } from 'src/shared/service-proxies/service-proxies';
import { interval  } from 'rxjs';
import { DateTimeHelper } from 'src/app/helpers/datetime'
import * as moment from 'moment';
import { JobItemModel, VehicleJobListItemModel } from '../models';
import { Router } from '@angular/router';

@Component({
  selector: 'app-widget-vehicle-jobs',
  templateUrl: './vehicle-jobs.component.html',
  styleUrls: ['./vehicle-jobs.component.scss']
})
export class VehicleJobsWidgetComponent implements OnChanges {
  // Inputs
  @Input()
  vehicleJobs: VehicleJobListItemDto[]

  // Private variables
  _pageRefeshTimer: any;
  _showingPage: number = 1;
  _vehiclesToShowPerPage: number = 5;

  // Public variables
  vehicleJobPage: VehicleJobListItemModel[] = [];

  constructor(private router: Router) { }

  ngOnChanges(changes) {
    if (changes.vehicleJobs.currentValue && this._pageRefeshTimer == null) {
      this._showingPage = 1
      this._pageRefeshTimer = interval(20000);
      this._pageRefeshTimer.subscribe(val => {
        this.changePage();
      })
    }
    
    if (changes.vehicleJobs.firstChange === false) {
      this.updateView();
    }
  }

  changePage() {
    if (this.vehicleJobs.length > this._vehiclesToShowPerPage) {
      let totalPages = Math.ceil(this.vehicleJobs.length / this._vehiclesToShowPerPage);
      if (this._showingPage + 1 <= totalPages) {
        this._showingPage++;
      } else {
        this._showingPage = 1;
      }
      this.updateView();
    }
  }

  updateView() {
    let page:  VehicleJobListItemModel[] = [];
    let vehicleNo = 1;
    this.vehicleJobs.forEach(vehicle => {
      // Figure out which vehicles to show in the current page.
      if (vehicleNo > ((this._showingPage - 1) * this._vehiclesToShowPerPage) && (vehicleNo <= (this._showingPage) * this._vehiclesToShowPerPage)) {
        const vehicleModel: VehicleJobListItemModel = this.MapDtoToModel(vehicle);
        // Add dummy rows so each vehicle has three rows
        if (vehicleModel.jobItems.length < 3) {
          while (vehicleModel.jobItems.length < 3) {
            const item: JobItemModel = <JobItemModel>{}
            item.fromLocation = ""
            vehicleModel.jobItems.push(item)
          }
        }

        page.push(vehicleModel);
      }

      vehicleNo++;
    });

    this.vehicleJobPage = page;
  }

  goToRouteMap(movementId: number) {
    this.router.navigate([`/route-map/${movementId}`]);
  }

  showVariance() {
    return true; // this.vehicleJobs?.some(v => v.jobs?.some(j => j.variance || j.mileageVariance));
  }

  MapDtoToModel(dto: VehicleJobListItemDto): VehicleJobListItemModel {
    let model: VehicleJobListItemModel = dto;
    model.jobItems = dto.jobs;
    let isFirstRow = true;
    model.jobItems.forEach(item => {
      item.isFirstRow = isFirstRow;
      item.journeyTimeMinutesFormatted = DateTimeHelper.formatTimespan(item.journeyTimeMinutes);
      item.arrivedAtFormatted = DateTimeHelper.formatDateToTime(item.arrivedAt);
      item.departedAtFormatted = DateTimeHelper.formatDateToTime(item.departedAt);
      if (item.mileage) {
        item.mileageFormatted =  Math.round(item.mileage * 10) / 10;
      }
      item.mileageVarianceFormatted = Math.round(item.mileageVariance * 10) / 10;
      isFirstRow = false;
    });

    return model;
  }

}
